'use client';

import { createAdapterProvider, renderQueryString } from '../chunk-OMREKXUP.js';
import { useNavigate, useSearchParams } from 'react-router-dom';

function useNuqsReactRouterAdapter() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const updateUrl = (search, options) => {
    navigate(
      {
        search: renderQueryString(search)
      },
      {
        replace: options.history === "replace",
        preventScrollReset: !options.scroll
      }
    );
  };
  return {
    searchParams,
    updateUrl
  };
}
var NuqsAdapter = createAdapterProvider(useNuqsReactRouterAdapter);

export { NuqsAdapter };
